import type { DomainMapper } from '../types';

const de: DomainMapper = {
  countryCode: 'de',
  currency: 'EUR',
  dataAreaId: 'de20',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/DE.svg',
  languagePrimary: true,
  locale: 'de',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-de.xml',
  storyblokBasePath: 'de',
  url: 'https://kahrs-preview.iveo.store/de',
  algoliaIndex: 'b2b-de-de-DE-products',
  algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1355,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1355,
    algoliaIndex: 'b2b-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-de.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1423,
    algoliaIndex: 'b2c-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-de-de-DE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-de-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    onlyAllowCustomerEditAddressesForSamples: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default de;
